var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStepActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 4"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 106",
    cx: 11,
    cy: 11,
    r: 10,
    stroke: "#E4E4E7",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 107"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_0_121",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5588 16.4433C21.3766 15.0072 21.8602 13.4054 21.9739 11.7568C22.0876 10.1081 21.8284 8.45503 21.2155 6.92033C20.6026 5.38563 19.6518 4.00875 18.4337 2.89196C17.2156 1.77518 15.7615 0.947202 14.1795 0.469535L13.6037 2.37648C14.8993 2.76765 16.09 3.44569 17.0875 4.36024C18.085 5.27478 18.8637 6.40233 19.3656 7.65911C19.8675 8.9159 20.0798 10.2696 19.9867 11.6197C19.8936 12.9698 19.4975 14.2816 18.8278 15.4576L20.5588 16.4433Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20.5588 16.4433C21.3766 15.0072 21.8602 13.4054 21.9739 11.7568C22.0876 10.1081 21.8284 8.45503 21.2155 6.92033C20.6026 5.38563 19.6518 4.00875 18.4337 2.89196C17.2156 1.77518 15.7615 0.947202 14.1795 0.469535L13.6037 2.37648C14.8993 2.76765 16.09 3.44569 17.0875 4.36024C18.085 5.27478 18.8637 6.40233 19.3656 7.65911C19.8675 8.9159 20.0798 10.2696 19.9867 11.6197C19.8936 12.9698 19.4975 14.2816 18.8278 15.4576L20.5588 16.4433Z",
    stroke: "#0D70DC",
    strokeWidth: 4,
    mask: "url(#path-2-inside-1_0_121)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepActive);
export default __webpack_public_path__ + "static/media/step-active.c2b4cdd1245b6f74ecd4a6d40c42ec4f.svg";
export { ForwardRef as ReactComponent };